import React, { useEffect } from 'react';
import { BrowserRouter as Router, Redirect, Route, Switch, withRouter } from 'react-router-dom';

import Login from './pages/Login';
import AdminApp from './pages/admin';
import SignupForm from './pages/SignupForm';
import CheckMailbox from './pages/CheckMailbox';
import Spinner from './components/Spinner';
import { useDispatch, useSelector } from 'react-redux';
import { getUserInfo, selectUserInfo } from './features/users/userInfoSlice';
import { localSignIn } from './features/users/loginSlice';
import Dashboard from './pages/client/dashboard';
import NavigationLayout from './Layouts/NavigationLayout';
import Acquisition from './pages/client/acquisition';
import Websites from './pages/client/websites';
import PasswordRecovery from './pages/PasswordRecover';
import ResetPassword from './pages/ResetPassword';
import Visibility from './pages/client/visibility';
import IframeView from './pages/client/IframeView';

const PrivateR = ({ component: Component, auth, path, ...rest }) => {
  const dispatch = useDispatch();
  const userInfo = useSelector(selectUserInfo);


  useEffect(() => {
    dispatch(getUserInfo());
  }, []);

  useEffect(() => {
    if (userInfo.user !== null && !userInfo.loading) dispatch(localSignIn())
  }, [userInfo?.user?.company_id])

  if (userInfo.loading)
    return (
      <div className="w-full mx-auto flex justify-center mt-40">
        <Spinner />
      </div>
    );

  return (
    <Route
      {...rest}
      render={(props) => {
        if (userInfo.error || !userInfo.user)
          return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
        return (
          <NavigationLayout>
            <Component {...props} />
          </NavigationLayout>
        );
      }}
    />
  );
};

const PrivateRoute = withRouter(PrivateR);

export const MainRouter = () => {
  return (
    <Router>
      <Switch>
        <Route path="/login">
          <Login />
        </Route>
        <Route path="/signup">
          <SignupForm />
        </Route>
        <Route path="/check-mailbox">
          <CheckMailbox />
        </Route>
        <Route path='/recovery-password' component={PasswordRecovery} />
        <Route path='/reset-password' component={ResetPassword} />
        <PrivateRoute path="/account" component={Dashboard} />
        <PrivateRoute path="/visibility" component={Visibility} />
        <PrivateRoute path="/trafic" component={Acquisition} />
        <PrivateRoute path="/websites" component={Websites} />
        <PrivateRoute path="/admin" component={AdminApp} />
        <PrivateRoute path='/contact' component={IframeView} />
        <PrivateRoute path="/" component={Dashboard} />
      </Switch>
    </Router>
  );
};
